const dictionary = {
    vi: {
        messages:{
            alpha: field => field + ' không đúng định dạng',
            alpha_spaces: field => field + ' không đúng định dạng',
            alpha_dash: field => field + ' không đúng định dạng',
            regex: field => field + ' không đúng định dạng',
            required: field => field + ' không được để trống',
            phone: field => field + ' không đúng',
            confirmed: field => field + ' không khớp, vui lòng kiểm tra lại',
            min: (field,arg) => field + ' phải có ít nhất ' + arg + ' ký tự',
            max: (field,arg) => field + ' tối đa có ' + arg + ' ký tự',
            url: field => field + '  của bạn không đúng định dạng.',
            ensure_url: field => field + '  của bạn không đúng định dạng.',
            email: field => field + ' của bạn không đúng định dạng.',
            no_spaces: field => field + ' không được chứa khoảng trắng.',
            not_digits: field => field + ' không được chứa số.',
            not_symbols: field => field + ' không được chứa ký tự đặc biệt.',
            password_level_1: field => field + ' phải có ít nhất 8 ký tự, một chữ hoa, một chữ thường và một số.',
            numeric: field => field + ' bắt buộc phải là số',
            not_symbols_allowed_space: field => field + ' không được chứa ký tự đặc biệt',
            customer_identity_number: field => field + ' 9 số hoặc 12 sô',
            not_allowed_vietnamese: field => field + ' không chứ ký tự có dấu',
            different: field => field + ' không được giống email trước đó',
            different_pw: field => field + ' không được giống mật khẩu cũ',
            ten_length: field => field + ' không hợp lệ',
            cmnd_number: field => field + ' không hợp lệ',
            custom_required: field => 'Vui lòng nhập ' + field
        }
    },
    en: {
        messages:{
            alpha: field => field + ' is not correct',
            alpha_spaces: field => field + ' is not correct',
            alpha_dash: field => field + ' is not correct',
            regex: field => field + ' is not correct',
            required: field => field + ' is required',
            phone: field => field + ' is not correct',
            confirmed: field => field + ' not matched, please check again',
            min: (field,arg) => field + ' has minimum of ' + arg + ' characters',
            max: (field,arg) => field + ' has maximum ' + arg + ' characters',
            url: field => field + ' is not correct',
            ensure_url: field => field + ' is not correct',
            email: field => field + ' is not correct',
            no_spaces: field => field + ' don\'t include spaces',
            not_digits: field => field + ' must not contain numbers',
            not_symbols: field => field + ' does not contain special characters',
            password_level_1: field => field + ' must contain at least 8 characters, one uppercase letter, one lowercase letter and one number.',
            numeric: field => field + ' is number required',
            not_symbols_allowed_space: field => field + ' does not contain special characters',
            customer_identity_number: field => field + ' is 9 or 12 number',
            not_allowed_vietnamese: field => field + ' does not contain special characters',
            different: field => field + ' does not same as email before',
            different_pw: field => field + ' must be different from the old password',
            ten_length: field => field + ' is not valid',
            cmnd_number: field => field + ' is not valid',
            custom_required: field => field + ' is required'
        }
    }
};
export default dictionary



// WEBPACK FOOTER //
// ./src/plugins/veeValidate/dictionary.js